var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7482 4.92206C16.1756 5.17533 15.5684 5.34166 14.9467 5.41556C15.602 5.02363 16.0925 4.40682 16.3267 3.68006C15.7117 4.04606 15.0374 4.30256 14.3347 4.44131C13.8626 3.93624 13.237 3.60128 12.5549 3.4885C11.8729 3.37571 11.1726 3.49143 10.5631 3.81765C9.95363 4.14387 9.46898 4.66232 9.18452 5.2924C8.90007 5.92249 8.83175 6.62889 8.99019 7.30181C7.74302 7.2393 6.52294 6.9152 5.40915 6.35056C4.29537 5.78591 3.31278 4.99335 2.52519 4.02431C2.24641 4.50315 2.0999 5.04748 2.10069 5.60156C2.10069 6.68906 2.65419 7.64981 3.49569 8.21231C2.99769 8.19663 2.51066 8.06215 2.07519 7.82006V7.85906C2.07534 8.58333 2.32596 9.28527 2.78457 9.84585C3.24318 10.4064 3.88155 10.7912 4.59144 10.9348C4.12915 11.0601 3.64442 11.0786 3.17394 10.9888C3.37409 11.6122 3.76419 12.1575 4.28963 12.5481C4.81507 12.9388 5.44953 13.1554 6.10419 13.1676C5.45355 13.6786 4.70857 14.0563 3.91185 14.2792C3.11513 14.5021 2.28228 14.5658 1.46094 14.4666C2.89471 15.3886 4.56376 15.8782 6.26844 15.8766C12.0382 15.8766 15.1934 11.0968 15.1934 6.95156C15.1934 6.81656 15.1897 6.68006 15.1837 6.54656C15.7978 6.10269 16.3279 5.55282 16.7489 4.92281L16.7482 4.92206Z",
    fill: "#9FDCE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.128906 0.680847)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5136f54b23052aca25932dc0340eb7f6.svg";
export { ForwardRef as ReactComponent };